import React from 'react';

function About() {
  return (
    <section id="homeabout" className="bd-about__area section-space theme-bg-secondary">
      <div className="container">
        <div className="row g-5 align-items-lg-center">
          <div className="col-lg-12 col-md-12">
            <div className="about__content">
              <div className="section__title-wrapper text-center">
                <span className="section__subtitle text-uppercase">A short intro</span>
              </div>
              <p className="about__text text-white text-justify">
                I’m a passionate web developer with 3 years of experience specializing in Core PHP,
                Laravel, and MySQL for backend development, and HTML, CSS, JavaScript, and
                Bootstrap for crafting responsive and engaging frontends. I’m skilled in deploying
                websites on hosting platforms and managing servers, ensuring seamless performance.
                With experience in Adobe Photoshop, I design visually appealing graphics for web
                projects. Currently, I’m expanding my expertise by learning ReactJS to build
                modern, dynamic applications. Let's create something amazing together!
              </p>
              <div className="about__btn text-center">
                <a className="bd-btn is-btn-anim" href="tel:+918300923800">
                  <span className="bd-btn-inner">
                    <span className="bd-btn-normal">
                      Hire Me <i className="fab fa-telegram-plane"></i>
                    </span>
                    <span className="bd-btn-hover">
                      Hire Me <i className="fab fa-telegram-plane"></i>
                    </span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
